export default __webpack_public_path__ + "static/media/intro_overlay.bf2d02a3.png";